import { motion } from "framer-motion";

import drink1 from "../../../assets/Drinks/drink1.jpg";
import drink2 from "../../../assets/Drinks/drink2.jpg";
import drink3 from "../../../assets/Drinks/drink3.jpg";
import drink4 from "../../../assets/Drinks/drink4.jpg";
import drink5 from "../../../assets/Drinks/drink5.jpg";
import drink6 from "../../../assets/Drinks/drink6.jpg";
import drink7 from "../../../assets/Drinks/drink7.jpg";
import drink8 from "../../../assets/Drinks/drink8.jpg";

const drinksItems = [
  { title: "Basil lemonade", price: "₹585",  img: drink1 },
  { title: "Sex on the beach", price: "₹860",  img: drink2 },
  { title: "Glace", price: "₹550",  img: drink3 },
  { title: "Cappuccino", price: "₹500", img: drink4 },
  { title: "Pina colada", price: "₹890", img: drink5 },
  { title: "Cosmopolitan", price: "₹870", img: drink6 },
  { title: "Mojito", price: "₹680", img: drink7 },
  { title: "Bloody mary", price: "₹899", img: drink8 },
];

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.08,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const Drinks = () => {
  return (
    <section className="bg-neutral-100 py-20">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="font-italianno text-primary-800 text-3xl sm:text-4xl">
            Menu
          </span>

          <h2 className="text-primary-700 text-2xl sm:text-3xl xl:text-4xl font-semibold tracking-widest mt-1">
            DRINKS
          </h2>

          <div className="w-14 h-px bg-primary-400 mx-auto mt-4" />
        </motion.div>

        {/* Grid */}
         <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-6 xl:gap-8">
          {drinksItems.map((item, index) => (
            <motion.div
              key={index}
              custom={index}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="bg-white overflow-hidden shadow-sm hover:shadow-lg transition-shadow"
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-48 sm:h-52 xl:h-56 2xl:h-60 object-cover"
              />

              <div className="p-4 xl:p-5 2xl:p-6">
                <div className="flex justify-between items-start gap-2">
                  <h4 className="text-primary-700 font-semibold text-sm xl:text-base leading-snug">
                    {item.title}
                  </h4>

                  <span className="text-primary-800 font-semibold text-sm xl:text-base whitespace-nowrap">
                    {item.price}
                  </span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Drinks;